export var FIELD_TEXT = 'FIELDS_INPUT_TEXT';
export var FIELD_TEXTAREA = 'FIELDS_INPUT_TEXTAREA';
export var FIELD_TITLE = 'FIELDS_ELEMENT_TITLE';
export var FIELD_DESCRIPTION = 'FIELDS_ELEMENT_DESCRIPTION';